export const keySkills = [
    "Machine Learning",
    "Statistical Analysis",
    "Python Programming",
    "Data Visualization",
    "Big Data Technologies",
    "Predictive Modeling",
    "SQL Databases",
    "Data Cleaning",
    "Artifical Intelligence",
    "Deep Learning",
];

export const targetJobTitles = [
    "Senior Data Scientist",
    "Lead Data Scientist",
    "Principal Data Scientist",
    "Data Science Manager",
    "Machine Learning Engineer",
    "Artifical Intelligence Specialist",
    "Data Analyst",
    "Data Engineer",
    "BI Developer",
    "Predictive Analyst",
];

export const tags = [
    "Machine Learning",
    "Data Science",
    "Python",
    "Big Data",
    "Predictive Analytics",
    "SQL",
    "AI",
    "Deep Learning",
    "North America",
    "Technology Industry",
    "Senior Level",
];

export const questions = [
    {
        id: 1,
        questionAbout: "Programming & scripting",
        questionDetail:
            "Assesses the candidate's proficiency in programming languages commonly used in machine learning, such as Python.",
        question:
            "How have you used data science to improve operational efficiency in a past project, and what were the results?",
        hint: "Lörem ipsum protism soködade att pseudoligen semick, transcism heteromatisk och heteroska metrogam endotyp. Lörem ipsum protism soködade att pseudoligen semick Lörem ipsum protism soködade att pseudoligen semick, transcism heteromatisk och heteroska metrogam endotyp. Lörem ipsum protism soködade att pseudoligen semick",
        skillsAdded: ["Python", "Machine Learning", "Data Science"],
        questionType: "Technical",
        questionDifficultyLevel: "Easy",
        expectedAnswer:
            "Handling missing data is a crucial step in data preprocessing. In Python, you can handle missing data using libraries like Pandas. Techniques include: ignoring missing values, filling them with a specific value (mean, median, mode), or imputing them using models. For instance, using Pandas, you can use `fillna()` to replace NaNs, or `dropna()` to remove missing values. If using mean imputation, `df.fillna(df.mean())` can be used. Choosing the method depends on the data context and the impact on analysis. Advanced techniques might involve using regression models to predict missing data values.",
        keyEvaluationPoint: [
            "Correct use of Python libraries",
            "Understanding of different imputation techniques",
            "Ability to select the appropriate method",
        ],
        redFlags: [
            "Inability to name basic Python functions",
            "No context-based decision making",
            "Inaccurate handling of data integrity",
        ],
    },
    {
        id: 2,
        questionAbout: "Programming & scripting",
        questionDetail:
            "Assesses the candidate's proficiency in programming languages commonly used in machine learning, such as Python.",
        question:
            "How have you used data science to improve operational efficiency in a past project, and what were the results?",
        hint: "Lörem ipsum protism soködade att pseudoligen semick, transcism heteromatisk och heteroska metrogam endotyp. Lörem ipsum protism soködade att pseudoligen semick Lörem ipsum protism soködade att pseudoligen semick, transcism heteromatisk och heteroska metrogam endotyp. Lörem ipsum protism soködade att pseudoligen semick",
        skillsAdded: ["Python", "Machine Learning", "Data Science"],
        questionType: "Technical",
        questionDifficultyLevel: "Medium",
        expectedAnswer:
            "Handling missing data is a crucial step in data preprocessing. In Python, you can handle missing data using libraries like Pandas. Techniques include: ignoring missing values, filling them with a specific value (mean, median, mode), or imputing them using models. For instance, using Pandas, you can use `fillna()` to replace NaNs, or `dropna()` to remove missing values. If using mean imputation, `df.fillna(df.mean())` can be used. Choosing the method depends on the data context and the impact on analysis. Advanced techniques might involve using regression models to predict missing data values.",
        keyEvaluationPoint: [
            "Correct use of Python libraries",
            "Understanding of different imputation techniques",
            "Ability to select the appropriate method",
        ],
        redFlags: [
            "Inability to name basic Python functions",
            "No context-based decision making",
            "Inaccurate handling of data integrity",
        ],
    },
    {
        id: 3,
        questionAbout: "Programming & scripting",
        questionDetail:
            "Assesses the candidate's proficiency in programming languages commonly used in machine learning, such as Python.",
        question:
            "How have you used data science to improve operational efficiency in a past project, and what were the results?",
        hint: "Lörem ipsum protism soködade att pseudoligen semick, transcism heteromatisk och heteroska metrogam endotyp. Lörem ipsum protism soködade att pseudoligen semick Lörem ipsum protism soködade att pseudoligen semick, transcism heteromatisk och heteroska metrogam endotyp. Lörem ipsum protism soködade att pseudoligen semick",
        skillsAdded: ["Python", "Machine Learning", "Data Science"],
        questionType: "Technical",
        questionDifficultyLevel: "Hard",
        expectedAnswer:
            "Handling missing data is a crucial step in data preprocessing. In Python, you can handle missing data using libraries like Pandas. Techniques include: ignoring missing values, filling them with a specific value (mean, median, mode), or imputing them using models. For instance, using Pandas, you can use `fillna()` to replace NaNs, or `dropna()` to remove missing values. If using mean imputation, `df.fillna(df.mean())` can be used. Choosing the method depends on the data context and the impact on analysis. Advanced techniques might involve using regression models to predict missing data values.",
        keyEvaluationPoint: [
            "Correct use of Python libraries",
            "Understanding of different imputation techniques",
            "Ability to select the appropriate method",
        ],
        redFlags: [
            "Inability to name basic Python functions",
            "No context-based decision making",
            "Inaccurate handling of data integrity",
        ],
    },
    {
        id: 4,
        questionAbout: "Programming & scripting",
        questionDetail:
            "Assesses the candidate's proficiency in programming languages commonly used in machine learning, such as Python.",
        question:
            "How have you used data science to improve operational efficiency in a past project, and what were the results?",
        hint: "Lörem ipsum protism soködade att pseudoligen semick, transcism heteromatisk och heteroska metrogam endotyp. Lörem ipsum protism soködade att pseudoligen semick Lörem ipsum protism soködade att pseudoligen semick, transcism heteromatisk och heteroska metrogam endotyp. Lörem ipsum protism soködade att pseudoligen semick",
        skillsAdded: ["Python", "Machine Learning", "Data Science"],
        questionType: "Technical",
        questionDifficultyLevel: "Hard",
        expectedAnswer:
            "Handling missing data is a crucial step in data preprocessing. In Python, you can handle missing data using libraries like Pandas. Techniques include: ignoring missing values, filling them with a specific value (mean, median, mode), or imputing them using models. For instance, using Pandas, you can use `fillna()` to replace NaNs, or `dropna()` to remove missing values. If using mean imputation, `df.fillna(df.mean())` can be used. Choosing the method depends on the data context and the impact on analysis. Advanced techniques might involve using regression models to predict missing data values.",
        keyEvaluationPoint: [
            "Correct use of Python libraries",
            "Understanding of different imputation techniques",
            "Ability to select the appropriate method",
        ],
        redFlags: [
            "Inability to name basic Python functions",
            "No context-based decision making",
            "Inaccurate handling of data integrity",
        ],
    },
];